var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("欢迎来到我们的支持页面")]),_c('button',{on:{"click":_vm.initiateChat}},[_vm._v("开始聊天")])])
}
var staticRenderFns = []

export { render, staticRenderFns }